module.exports = __webpack_public_path__ + "static/Intone-ab5f780d4bfd19555836c19666a1c42b.png";